import { defineStore } from 'pinia';
import { USER_STORE_SUPPLIER } from '~/assets/js/mappers/maps/UserStore.map';

const useUserStore = defineStore('user', USER_STORE_SUPPLIER);

export { useUserStore };
